import React, { useMemo } from 'react';
import { colors, Icon, Spinner, Button } from '@iq/react-components';

import { useSubscription } from '../../../../bundles/visualizations';
import { getActiveStates } from '../../../../bundles/statesets';
import LabelWithTooltip from '../../../LabelWithTooltip';

const StateVisualization = ({ isPreview = false, visualization, panelId, disconnected }) => {
  const { id, configuration = {}, variables } = visualization;
  const { loading, latestValues: values } = useSubscription(id, panelId);

  const statefulVarsWithValues = useMemo(
    () =>
      variables
        .filter((v) => v.stateset)
        .map((v) => {
          const varData = values?.find((val) => val.variable === v.id);
          const lastValue = varData?.value.at(-2) || null;
          const lastValueQuality = varData?.value.at(-1) || null;

          return { ...v, value: lastValue, quality: lastValueQuality };
        }),
    [values, variables]
  );
  const activeStates = getActiveStates(statefulVarsWithValues);

  // invalidate if quality !== 1 (valid) or no data connectivity (disconnected)
  const isDataInvalid = statefulVarsWithValues.some((value) => value.quality > 1) || disconnected;

  const getIcon = (states) => {
    if (!states.length) {
      return (
        <Icon
          icon="he-status"
          size="s"
          style={{ color: colors.Grey50 }}
        />
      );
    }
    if (states.length === 1) {
      return (
        <>
          <Icon
            icon="he-status"
            size="s"
            style={{ color: states[0].color }}
          />
          <p className="state-text">{states[0].text}</p>
        </>
      );
    }
    return (
      <Icon
        icon="he-help"
        size="s"
        style={{ color: colors.StatusRed }}
      />
    );
  };

  return (
    <div
      className={`state-visualization-component ${isPreview ? 'preview' : 'normal'} ${
        isDataInvalid ? 'invalid-data' : ''
      }`}
    >
      <div className="wrapper">
        {loading ? <Spinner /> : getIcon(activeStates)}
        <div className="label">
          <LabelWithTooltip name={configuration?.label} />
          {isDataInvalid ? (
            <Button
              tooltip="Invalid state"
              design="text"
            >
              <Icon
                icon="he-help"
                size="s"
                color="#FF7300"
              />
            </Button>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default StateVisualization;
